<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 class="headline-m">
                {{ financingTitle | translate }}
            </h1>
            <h2 class="subtitle-xl">
                {{ financingSubtitle | translate }}
            </h2>
        </div>

        <ul class="list">
            <li class="feature">
                <div class="box">
                    <i class="ri-pass-valid-line class-icono"></i>
                </div>
                <div class="feature-text">
                    <span class="feature-text-title">{{ identityDocument | translate }}</span>
                    <span class="feature-text-paragraph">{{ rememberValidity | translate }}</span>
                </div>
            </li>
            <!-- Oculto de cara a futuro -->
            <!-- <li class="feature">
                <div class="box">
                    <i class="ri-smartphone-line class-icono"></i>
                </div>
                <div class="feature-text">
                    <span class="feature-text-title">{{ mobilePhone | translate }}</span>
                    <span class="feature-text-paragraph">{{ authenticateMobilePhone | translate }}</span>
                </div>
            </li> -->
            <li class="feature">
                <div class="box">
                    <i class="ri-wifi-line class-icono"></i>
                </div>
                <div class="feature-text">
                    <span class="feature-text-title">{{ internetConnection | translate }}</span>
                    <span class="feature-text-paragraph">{{ processQuick | translate }}</span>
                </div>
            </li>
        </ul>

        <div class="actions">
            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
